/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { ACTION_TYPES, getPriceStr } from "./utils"
import { useLocation } from "@reach/router"

const SeoResults = ({
  description,
  lang,
  meta,
  title,
  searchParams,
  location,
}) => {
  const { areas, bedrooms, pType, type, price, commType } = searchParams
  const area_name = searchParams.areas.replace(/-/g, " ")
  const pricerange = searchParams.price
  const minprice = searchParams.price.min
  const maxprice = searchParams.price.max
  const propType = searchParams.type.replace(/-/g, " ")

  const actionStr = ACTION_TYPES[pType]
  const priceStr = getPriceStr(price)
  const bedRooms = searchParams.bedrooms

  let propertyType = ""

  let areaname =
    area_name === "stoke newington and hackney and north london and east london"
      ? "Stoke Newington, Hackney, North and East London"
      : area_name

  if (type == "") {
    propertyType = "property"
  } else {
    propertyType = type.replace(/-/g, " ")
  }

  const capitalize = data => {
    if (typeof data !== "string") return ""
    return data
      .toLowerCase()
      .split(" ")
      .map(s => s.charAt(0).toUpperCase() + s.substring(1))
      .join(" ")
  }

  let desc = ""
  desc =
    "Find the wide range of property" +
    actionStr +
    "" +
    capitalize(areaname) +
    ". Contact our property specialists and avail help to find the right Property" +
    actionStr +
    capitalize(areaname) +
    "."
  if (pricerange.min || pricerange.max) {
    desc =
      "Discover the best property" +
      actionStr +
      capitalize(areaname) +
      priceStr +
      " with Location Location Estate agents. Book an appointment with one of our specialists in " +
      capitalize(areaname) +
      "."
  }
  if (propType) {
    desc = `Looking for ${propertyType}s${actionStr}${capitalize(
      areaname
    )}? Location Location property experts are here to help.`
  }

  if (bedRooms) {
    desc =
      "Discover properties" +
      actionStr +
      capitalize(areaname) +
      " " +
      "with more than" +
      " " +
      bedRooms +
      " bedroom here. Book an appointment with one of our specialists today to get assistance in finding the perfect property in " +
      capitalize(areaname) +
      "."
  }

  if ((pricerange.min || pricerange.max) && propType) {
    desc =
      "Browse through the latest collection of " +
      propertyType +
      "s" +
      actionStr +
      capitalize(areaname) +
      priceStr +
      " with Location Location, the leading estate agents and letting agents in the " +
      capitalize(areaname) +
      "."
  }

  if ((pricerange.min || pricerange.max) && bedRooms) {
    desc = `Explore properties${actionStr}${capitalize(
      areaname
    )} with more than ${bedRooms} bedrooms${priceStr} with Location Location and Book a Viewing for the property that interests you.`
  }
  if (propType && bedRooms) {
    desc = `Check the latest ${propertyType}s${actionStr}${capitalize(
      areaname
    )} with more than ${bedRooms} bedrooms. Contact Location Location, the leading estate agents and letting agents in ${capitalize(
      areaname
    )}, to book a viewing.`
  }

  if (minprice && propType && bedRooms) {
    desc = `Find ${propertyType}s${actionStr}${capitalize(
      areaname
    )} with more than ${bedRooms} bedrooms${priceStr} with Location Location. Book an appointment with one of our specialists today to get assistance in finding the perfect property in ${capitalize(
      areaname
    )}.`
  }
  if (maxprice && propType && bedRooms) {
    desc = `Find ${propertyType}s${actionStr}${capitalize(
      areaname
    )} with more than ${bedRooms} bedrooms${priceStr} with Location Location. Book an appointment with one of our specialists today to get assistance in finding the perfect property in ${capitalize(
      areaname
    )}.`
  }

  //
  let titlePropertyType = ""

  if (type == "") {
    titlePropertyType = "Property"
  } else if (type == "apartment") {
    titlePropertyType = "Apartments"
  } else if (type == "house-mid-terrace") {
    titlePropertyType = "Houses"
  } else if (type == "flat") {
    titlePropertyType = "Flats"
  } else if (type == "maisonette") {
    titlePropertyType = "Maisonettes"
  } else if (type == "property") {
    titlePropertyType = "Property"
  } else if (type == "bungalow") {
    titlePropertyType = "Bungalows"
  } else if (type == "land") {
    titlePropertyType = "Land"
  } else if (type == "commercial") {
    titlePropertyType = "Commercial"
  } else {
    titlePropertyType = type
  }

  let bedroomType = ""
  let bedrooms_type = ""

  if (bedrooms) {
    bedroomType = bedrooms + " bedroom "
    bedrooms_type = bedrooms + " bedrooms"
  }
  let descTitle = ""

  descTitle =
    bedroomType +
    capitalize(titlePropertyType.replace(/-/g, " ")) +
    actionStr +
    capitalize(areaname) +
    priceStr

  if (bedrooms) {
    descTitle = `Property ${actionStr} ${capitalize(
      areaname
    )} with more than ${bedrooms_type}`
  }

  if (pricerange.min || pricerange.max) {
    descTitle = `Property ${actionStr} ${capitalize(areaname)} ${priceStr}`
  }

  if (propType) {
    descTitle = `${capitalize(
      titlePropertyType.replace(/-/g, " ")
    )} ${actionStr} ${capitalize(areaname)}`
  }

  if ((pricerange.min || pricerange.max) && bedrooms) {
    descTitle = `Property ${actionStr} ${capitalize(
      areaname
    )} with more than ${bedroomType} ${priceStr}`
  }

  if ((pricerange.min || pricerange.max) && propType) {
    descTitle = `${capitalize(
      titlePropertyType.replace(/-/g, " ")
    )} ${actionStr} ${capitalize(areaname)} ${priceStr}`
  }

  if (propType && bedRooms) {
    descTitle = `${capitalize(
      titlePropertyType.replace(/-/g, " ")
    )} ${actionStr} ${capitalize(areaname)} with more than ${bedrooms_type}`
  }

  if (minprice && propType && bedRooms) {
    descTitle = `${capitalize(
      titlePropertyType.replace(/-/g, " ")
    )} ${actionStr} ${capitalize(
      areaname
    )} with more than ${bedrooms_type} ${priceStr}`
  }
  if (maxprice && propType && bedRooms) {
    descTitle = `${capitalize(
      titlePropertyType.replace(/-/g, " ")
    )} ${actionStr} ${capitalize(
      areaname
    )} with more than ${bedrooms_type} ${priceStr}`
  }

  // else if ((pricerange.min || pricerange.max) && propType) {
  //   descTitle = `${capitalize(
  //     titlePropertyType.replace(/-/g, " ")
  //   )} ${actionStr} ${capitalize(areaname)} ${priceStr}`
  // } else {
  //   descTitle =
  //     bedroomType +
  //     capitalize(titlePropertyType.replace(/-/g, " ")) +
  //     actionStr +
  //     capitalize(areaname) +
  //     priceStr
  // }
  //

  // console.log("Props Desc => ", desc);

  description = desc

  var { pathname } = useLocation()

  var currentUrl = ""
  currentUrl = process.env.GATSBY_SITE_URL + pathname

  // set no index for result pagination
  let hasPagination = false
  if (pathname !== undefined && pathname) {
    let pageStr = pathname.split("page-")
    hasPagination = pageStr[1] || false
    if (pageStr[0] !== undefined) {
      currentUrl = process.env.GATSBY_SITE_URL + pageStr[0]
    }
  }

  if (!currentUrl.endsWith("/")) currentUrl = currentUrl + "/"

  //remove multiple slashes
  currentUrl = currentUrl.replace(/([^:]\/)\/+/g, "$1")
  //set lowercase url
  currentUrl = currentUrl.toLowerCase()

  let metaItems = [
    {
      name: `description`,
      content: description,
    },
    {
      property: `og:title`,
      content: descTitle,
    },
    {
      property: `og:description`,
      content: description,
    },
    {
      property: `og:type`,
      content: `website`,
    },
    {
      name: `twitter:card`,
      content: `summary`,
    },
    {
      name: `twitter:creator`,
      content: `Location Location`,
    },
    {
      name: `twitter:title`,
      content: descTitle,
    },
    {
      name: `twitter:description`,
      content: description,
    },
  ].concat(meta)

  // set no index for result pagination
  // let hasPagination = false
  // if (location !== undefined && location.pathname) {
  //   let pageStr = location.pathname.split("page-")
  //   hasPagination = pageStr[1] || false
  // }
  //  if ( hasPagination ) {
  //    metaItems.push({
  //      name: `robots`,
  //      content: `noindex`,
  //    })
  //  }

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      link={[
        {
          href: currentUrl,
          rel: "canonical",
        },
      ]}
      title={descTitle}
      titleTemplate={`%s | Location Location`}
      meta={metaItems}
    />
  )
}

SeoResults.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
  title: ``,
  searchParams: [],
}

SeoResults.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
  searchParams: PropTypes.any,
}

export default SeoResults
